import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    endpoint: endpoints.image_upload.endpoint, // "reports-manager/counters-image-upload",
  },
  // -----------------------------------------------------------------
  getters: {
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.LIABILITY_COUNTERS_LOAD](state, liabilityCounters) {
      state.liabilityCounters = JSON.parse(JSON.stringify(liabilityCounters));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    upload: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data.data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
